import { FC } from 'react';
import { ButtonComponent, ButtonText } from './Link.styles';
import { ButtonProps } from '@sleepunique/types/button-type';
import { Icon } from '@sleepunique/components/atoms';

const Secondary: FC<ButtonProps> = ({
  children,
  disabled = false,
  icon,
  onClick = () => null,
  tabIndex,
  className,
  iconLeft,
  type,
}: ButtonProps) => (
  <ButtonComponent
    type={type}
    tabIndex={tabIndex}
    className={className}
    disabled={disabled}
    iconLeft={iconLeft}
    onClick={(event) => onClick(event)}
  >
    <ButtonText>{children}</ButtonText>
    {icon && <Icon icon={icon} size="xs" />}
  </ButtonComponent>
);

export default Secondary;
